import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../../elements-table/table';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { get, isEmpty, map } from 'lodash';
import { intlTaxTypeId } from '../../../../data/translationsData';
import { Schedule } from '../../../../../elements-forms/schedule';

const BookingDetailsSalesTaxComponent = ({
  address = {},
  guestDetails = {},
  schedule = [],
  timeZoneId,
  useType,
  invoiceFeeName,
  intl
}) => {
  const detailsTableHeaders = [
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_booking_details_table.location', defaultMessage: 'Billing Address' }),
      classname: 'flex-basis-25 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_booking_details_table.booking_start_date', defaultMessage: 'Space Address' }),
      classname: 'flex-basis-25 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_booking_details_table.booking_end_date', defaultMessage: 'Booking Date & Time' }),
      classname: 'flex-basis-25 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_booking_details_table.description', defaultMessage: 'Description' }),
      classname: 'flex-basis-25 text-transform-none'
    }
  ];

  const { city, country, state, street, unit, zip } = address;
  const { usersFullName, businessName, userOrganization, userAddressFormatArray, userVatId } = guestDetails;
  const feeLine = userVatId ? <div className="margin-md-top">
    <FormattedMessage {...get(intlTaxTypeId, invoiceFeeName, intlTaxTypeId.other)} />
    {userVatId}
  </div> : '';

  return (
    <div>
      <h4>
        <FormattedMessage
          id="hosting.sales_tax_booking_details_table.details"
          defaultMessage="Details" />
      </h4>
      <Table
        tableHeaders={detailsTableHeaders}
        tableBody={
          <div className="flex space-between table-row">
            <div className="flex-basis-25">
              <div className="margin-md-bottom text-gray-darker">
                {usersFullName && <div className="heavy">{usersFullName}</div>}
                {businessName && <div>{businessName}</div>}
                {userOrganization && <div>{userOrganization}</div>}
                {
                  map(userAddressFormatArray, (addressLine) => {
                    if (!isEmpty(addressLine)) {
                      return <div>{addressLine}</div>;
                    }
                  })
                }
                {feeLine}
              </div>
            </div>

            <div className="flex-basis-25">
              <div className="margin-md-bottom">
                <div>{street} {unit}</div>
                <div>{city}</div>
                <div>{state}</div>
                <div>{zip}</div>
                <div>{country}</div>
              </div>
            </div>

            <div className="flex-basis-25">
              <Schedule
                timeZoneId={timeZoneId}
                schedule={schedule}
              />
            </div>

            <div className="flex-basis-25">
              {useType}
            </div>
          </div>
        }
      />
    </div>
  );
};

BookingDetailsSalesTaxComponent.propTypes = {
  address: PropTypes.object,
  guestDetails: PropTypes.object,
  schedule: PropTypes.array,
  timeZoneId: PropTypes.string,
  useType: PropTypes.string,
  invoiceFeeName: PropTypes.string,
  intl: intlShape
};

export const BookingDetailsSalesTax = injectIntl(BookingDetailsSalesTaxComponent);
